import { classifyOwnAppUrl, isOwnAppHostname, URL_OWN_APP_REVIEW_ERROR } from '@overlayqa/shared';

/** Refuse our app while preserving the sandbox demo and customers' local sites. */
export function onboardingWebsiteError(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const url = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    return classifyOwnAppUrl(url) || isOwnAppHostname(new URL(url).hostname)
      ? URL_OWN_APP_REVIEW_ERROR : null;
  } catch {
    return null; // The field's syntax validation owns malformed URLs.
  }
}
